/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import { Languages } from './Languages'
import { toAbsoluteUrl } from '../../../helpers'
import { getCountryById } from '../../../../app/modules/country-management/core/_requests'
import { Country } from '../../../../app/modules/country-management/core/_models'
import { getStateById } from '../../../../app/modules/state-management/core/_requests'
import { State } from '../../../../app/modules/state-management/core/_models'
import { getCityById } from '../../../../app/modules/city-management/core/_requests'
import { City } from '../../../../app/modules/city-management/core/_models'
import { fileCheck, getUserById, getDbExport } from '../../../../app/modules/apps/user-management/core/_requests'
import { Modal } from 'react-bootstrap'

const HeaderUserMenu: FC = () => {
  const { currentUser, logout } = useAuth()
  const user_role = currentUser?.user;
  const slugs: any[] = [];

  if (user_role && user_role.roles && user_role.roles.length > 0) {
    // const slugs = user_role.roles[0].slug;
    user_role.roles.forEach(role => {
      slugs.push(role.slug);
    });
  }

  const country_id = currentUser && currentUser.user && currentUser.user.country_id
  const state_id = currentUser && currentUser.user && currentUser.user.state_id
  const city_id = currentUser && currentUser.user && currentUser.user.city_id


  const [countryName, setCountry] = useState<Country | null>(null);

  const [stateName, setState] = useState<State | null>(null);

  const [cityName, setCity] = useState<City | null>(null);

  const [fileExist, setFileExist] = useState(true);

  // const checkFileExistence = async (filename: any) => {
  //   try {
  //     const response = await fileCheck(filename);

  //     // const data = await response.json();

  //     if (response.exists === true) {
  //       setFileExist(true)
  //     } else {
  //       setFileExist(false)
  //     }
  //   } catch (error) {
  //     setFileExist(false)
  //   }
  // };


  // useEffect(() => {
  //   if (currentUser?.user?.profile_photo) {
  //     checkFileExistence(currentUser?.user?.profile_photo);
  //   }
  // }, [currentUser]);


  useEffect(() => {
    if (country_id != 0 && country_id != null) {
      getCountryById(currentUser?.user?.country_id).then((result) => {
        if (result) {
          setCountry(result as Country);
        }
      });
    }
  }, [currentUser]);

  useEffect(() => {
    if (state_id != 0 && state_id != null) {
      getStateById(currentUser?.user?.state_id).then((result) => {
        if (result) {
          setState(result as State);
        }
      });
    }
  }, [currentUser]);

  useEffect(() => {
    if (city_id != 0 && city_id != null) {
      getCityById(currentUser?.user?.city_id).then((result) => {
        if (result) {
          setCity(result as City);
        }
      });
    }
  }, [currentUser]);

  const [dbBackup, setDbBackup] = useState(false);

  const handleDbDownload = async () => {
    try {
      setDbBackup(true);

      await getDbExport('').then((response: any) => {
        setDbBackup(false);

        if (response?.status === true) {

          window.open(process.env.REACT_APP_BACKEND_BASE_URL + '/storage/' + response?.filename, "_blank")
        } else {
          console.log('error')
        }
      })

    } catch (error) {
      console.log('Error: ', error);
    }
  };


  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-semibold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            {/* <img alt='Logo' src={toAbsoluteUrl('/media/avatars/300-2.jpg')} /> */}
            <img alt='Logo' src={fileExist ? (`${process.env.REACT_APP_BACKEND_BASE_URL}/profilepic/${currentUser?.user?.profile_photo}`) : (`${process.env.REACT_APP_BACKEND_BASE_URL}/profilepic/default.jpg`)} />

          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bold d-flex align-items-center fs-5'>
              {/* {currentUser?.user?.first_name} {currentUser?.user?.middle_name} */}
              <span className='badge badge-light-success fw-bold fs-8 px-2 py-1 ms-2'>{currentUser?.user?.first_name} {currentUser?.user?.last_name}</span>
            </div>
            <a href='#' className='fw-semibold text-muted text-hover-primary fs-7'>
              <> {currentUser?.email} {currentUser?.roles} </>
            </a>
          </div>
        </div>
      </div>
      <div className='separator my-2'></div>

      {/* <Languages /> */}

      <div className='menu-item px-5 my-1'>
        <Link
          // to='/crafted/account/overview'
          to={{ pathname: '/crafted/account/overview', }}
          state={{
            countryName: countryName,
            stateName: stateName,
            cityName: cityName,
            fileExist: fileExist,
          }}

          className='menu-link px-5'>
          My Profile
        </Link>
      </div>
      {
        (slugs.includes('')) &&
        (
          <div className='menu-item px-5'>
            <a onClick={handleDbDownload} className='menu-link px-5' >
              DB Backup
            </a>
          </div>
        )
      }

      {/* <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings/edit' className='menu-link px-5'>
          Account Settings
        </Link>
      </div> */}

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
